<app-base-page-template>
  <app-base-page-content-template>
    <app-clients-grid
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-clients-grid>
  </app-base-page-content-template>
</app-base-page-template>
